module.exports = __webpack_public_path__ + "static/media/image_7.c4bc0aab.png";